// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Firebase configuration (Replace with your actual config)
const firebaseConfig = {
    apiKey: "AIzaSyAvsy8HiM0xdTEtlrDdYEAolyNI5cgH72E",
    authDomain: "anatrxweb.firebaseapp.com",
    projectId: "anatrxweb",
    storageBucket: "anatrxweb.firebasestorage.app",
    messagingSenderId: "748905758879",
    appId: "1:748905758879:web:b26afa505e6a750c4022aa",
    measurementId: "G-Q26JG00FTN"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export { messaging, getToken, onMessage };
